import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getIntegrationsPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/reseni/integrace",
		[Locale.en]: "/solutions/integrations",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
